import React from 'react';
import { MagnifyingGlassMinusIcon, MagnifyingGlassPlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from '../hooks/useTranslation';

const ZOOM_LEVELS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4];

const ZoomControls = ({ zoom, onZoomChange, className = '' }) => {
  const { t } = useTranslation();

  const handleZoomIn = () => {
    const currentIndex = ZOOM_LEVELS.findIndex(z => z >= zoom);
    if (currentIndex < ZOOM_LEVELS.length - 1) {
      onZoomChange(ZOOM_LEVELS[currentIndex + 1]);
    }
  };

  const handleZoomOut = () => {
    const currentIndex = ZOOM_LEVELS.findIndex(z => z >= zoom);
    if (currentIndex > 0) {
      onZoomChange(ZOOM_LEVELS[currentIndex - 1]);
    } else if (currentIndex === 0) {
      // Já está no mínimo
      return;
    } else {
      // zoom está entre dois valores, pega o anterior
      const prevIndex = ZOOM_LEVELS.findIndex(z => z > zoom) - 1;
      if (prevIndex >= 0) {
        onZoomChange(ZOOM_LEVELS[prevIndex]);
      }
    }
  };

  const handleSelectChange = (e) => {
    onZoomChange(parseFloat(e.target.value));
  };

  const formatZoom = (value) => `${Math.round(value * 100)}%`;

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* Botão Zoom Out (-) */}
      <button
        onClick={handleZoomOut}
        disabled={zoom <= ZOOM_LEVELS[0]}
        className="flex items-center justify-center w-8 h-8 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        style={{ backgroundColor: '#101f00' }}
        title={t('zoom.zoomOut')}
      >
        <MagnifyingGlassMinusIcon className="w-4 h-4 text-white" />
      </button>

      {/* Select de Zoom */}
      <select
        value={zoom}
        onChange={handleSelectChange}
        className="px-3 py-1.5 rounded-lg text-sm font-medium transition-colors cursor-pointer focus:outline-none"
        style={{ backgroundColor: '#1a150d', color: 'white' }}
        title={t('zoom.selectZoom')}
      >
        {ZOOM_LEVELS.map(level => (
          <option key={level} value={level}>
            {formatZoom(level)}
          </option>
        ))}
      </select>

      {/* Botão Zoom In (+) */}
      <button
        onClick={handleZoomIn}
        disabled={zoom >= ZOOM_LEVELS[ZOOM_LEVELS.length - 1]}
        className="flex items-center justify-center w-8 h-8 rounded-lg disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        style={{ backgroundColor: '#101f00' }}
        title={t('zoom.zoomIn')}
      >
        <MagnifyingGlassPlusIcon className="w-4 h-4 text-white" />
      </button>

      {/* Botão Reset (100%) */}
      {zoom !== 1 && (
        <button
          onClick={() => onZoomChange(1)}
          className="px-2 py-1.5 rounded-lg text-xs font-medium transition-colors"
          style={{ backgroundColor: '#1a150d', color: 'white' }}
          title={t('zoom.reset')}
        >
          {t('zoom.fit')}
        </button>
      )}
    </div>
  );
};

export default ZoomControls;
